import React from 'react';
import { useIntl } from 'react-intl';

const AdminUploadPageUploadsListHeader = () => {
  const intl = useIntl();

  return (
    <tr>
      <th>
        {intl.formatMessage({ defaultMessage: 'ID' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Files' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Name' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Email' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Uploaded' })}
      </th>
      <th>
        {' '}
      </th>
    </tr>
  );
};

export default AdminUploadPageUploadsListHeader;
